import Vue from 'vue';
import App from './App.vue';

// Components
  //------------
  // VueAxios
  import axios from 'axios';
  import VueAxios from 'vue-axios';
  Vue.use(VueAxios, axios);
  Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_BASE_PATH;
  Vue.axios.defaults.headers.common['Accept-Language'] = window.localStorage.getItem('Language') || 'es';

  // VueMeta
  import VueMeta from 'vue-meta'
  Vue.use(VueMeta, {
    // optional pluginOptions
    refreshOnceOnNavigation: true
  });
  // ---

  // Store + router
  import store from './store/store';
  import router from './router';
  import { sync } from 'vuex-router-sync';
  sync(store, router);
  Vue.router = router;
  // ---

  // vue-auth
  Vue.use(require('@websanova/vue-auth'), {
    auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
    http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
    router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
    parseUserData (data) {
      return data || {}
    },
    rolesVar: 'rolesVar'
  });
  // ---

  // Vuelidate
  import Vuelidate from 'vuelidate';
  Vue.use(Vuelidate);
  // ---

  // Pagination
  Vue.component('pagination', require('laravel-vue-pagination'));
  // ---

  // Vue-multiple-select
  import Multiselect from 'vue-multiselect'
  Vue.component('multiselect', Multiselect);
  // ---

  // Vue social sharing
  import SocialSharing from 'vue-social-sharing'
  Vue.use(SocialSharing);
  // ---

  // NProgress
  import NProgress from 'vue-nprogress';
  Vue.use(NProgress);
  const nprogress = new NProgress({ parent: '.nprogress-container' });
  // ---

  // Google Analytics and Tag Manager(only in PROD)
  import VueAnalytics from 'vue-ua';
  import VueGtm from 'vue-gtm';
  if (process.env.NODE_ENV !== 'development') {
    if(process.env.VUE_APP_NAME === "Planetajob") {
      // Planetajob Analytics
      Vue.use(VueAnalytics, {
        appName: 'Planetajob',
        appVersion: '1.01',
        trackingId: 'UA-165991401-1',
        vueRouter: router
      });

      // Planetajob Tag Manager
      Vue.use(VueGtm, {
        id: 'GTM-KQK7G73',
        enabled: true,
        debug: false,
        vueRouter: router
      });
    } else {
      Vue.use(VueAnalytics, {
        appName: 'AicadJobs',
        appVersion: '1.01',
        trackingId: 'UA-47066743-5', // My analytics at the moment
        vueRouter: router
      });
    }
  }
  // ---

  // Custom components
  import Permissions from './assets/mixins/Permissions';
  import Toasters from './assets/mixins/Toasters';
  Vue.mixin(Permissions);
  Vue.mixin(Toasters);

  import VueSwitches from 'vue-switches';
  Vue.component('b-switch', VueSwitches);
  // ---
//------------

// Layouts
//------------
import Default from './layouts/Default.vue';
import Jobs from './layouts/Jobs.vue';
import FullWidth from './layouts/FullWidth.vue';
Vue.component('default-layout', Default);
Vue.component('jobs-layout', Jobs);
Vue.component('fullwidth-layout', FullWidth);
//------------


// STYLINGS
//------------
  // BootstrapVue
  import BootstrapVue from 'bootstrap-vue';
  import 'bootstrap/dist/css/bootstrap.css'
  import 'bootstrap-vue/dist/bootstrap-vue.css'
  Vue.use(BootstrapVue);
  // ---

  // Font Awesome
  import '@/assets/icons/fontawesome-brands';
  import '@/assets/icons/fontawesome-solid';
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  Vue.component('font-awesome-icon', FontAwesomeIcon);
  // ---
// ---

Vue.config.productionTip = false;

new Vue({
  nprogress,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
